import request from '@/utils/request'
import { getEnvObj } from '@/utils/env'
import api from './base-url.config'
import { getUrlKey } from '@/utils'
import store from '@/store/index'

const headers = {
  'sysCode': getUrlKey('sysCode') || 'ICAS'
}

// const headersConflict = {
//   'sysCode': 'ICAS',
//   'isConflict': true,
//   'sgs-userid': 'ICAS88484e4ade0c47e8b1379860195ddfb0'
// }

// iuop登录
// const headers1 = {
//   'ver': 'V3',
//   'sysCode': 'ICAS'
// }
// iuop注册
const headers2 = {
  'ver': 'V2',
  'sysCode': getUrlKey('sysCode') || 'ICAS'
}

// const headers3 = {
//   'ver': 'V3',
//   'sysCode': getUrlKey('sysCode') || 'ICAS'
// }

const obj = getEnvObj()
console.log('config.js配置参数', obj)
const loginConfig = {
  deviceId: '1223124',
  appKey: obj.APP_KEY,
  appSecret: obj.APP_SECRET
}
console.log('loginConfig', loginConfig)

// 注册
export function registerApi(data) {
  return request({
    url: api.register,
    method: 'post',
    data,
    headers: headers2
  })
}

// inex注册
export function inexRegisterApi(data) {
  data = Object.assign({}, loginConfig, data)
  return request({
    url: api.inexRegister,
    method: 'post',
    data,
    headers: headers2
  })
}

// 修改密码
export function passModifyApi(data) {
  return request({
    url: api.passModify,
    method: 'post',
    headers,
    data
  })
}

// 修改密码 - 冲突界面
export function passModifyConflictApi(data, headersConflict) {
  return request({
    url: api.passModifyConflict,
    method: 'post',
    headers: headersConflict,
    data
  })
}

// 冲突页面 - 获取冲突数据
export function getConflictListApi(params) {
  return request({
    url: api.getConflictList,
    method: 'get',
    params
  })
}

// 通过手机号重置密码
export function resetByPhoneApi(data) {
  return request({
    url: api.resetByPhone,
    method: 'post',
    headers,
    data
  })
}

// 通过邮箱重置密码
export function resetByEmailApi(data) {
  return request({
    url: api.resetByEmail,
    method: 'post',
    headers,
    data
  })
}

// 登录获取token
export function login(data, headers3) {
  data = Object.assign({}, loginConfig, data)
  return request({
    url: api.login,
    method: 'post',
    headers: Object.assign({}, headers3, { useCaptcha: 1 }),
    data
  })
}

// 登录获取token （新接入腾讯验证码方案）
export function loginV2(data, headers3) {
  data = Object.assign({}, loginConfig, data)
  return request({
    url: api.loginV2,
    method: 'post',
    headers: headers3,
    data
  })
}

// 登录获取ticket
export function loginGetTicketApi(data, headers3) {
  data = Object.assign({}, loginConfig, data)
  return request({
    url: api.loginGetTicket,
    method: 'post',
    headers: Object.assign({}, headers3, { useCaptcha: 1 }),
    data
  })
}

// 登录获取ticket（新接入腾讯验证码方案）
export function loginGetTicketV2Api(data, headers3) {
  data = Object.assign({}, loginConfig, data)
  return request({
    url: api.loginGetTicketV2,
    method: 'post',
    headers: headers3,
    data
  })
}

// 退出登录
export function logout(params) {
  return request({
    url: api.logout,
    method: 'get',
    params
  })
}
// 注销账号
export function cancelApi(cancelToken) {
  return request({
    url: api.cancel,
    method: 'get',
    cancelToken // 用于中断请求
  })
}

// 注销账号 V2
export function cancelV2Api(data) {
  return request({
    url: api.cancelV2,
    method: 'post',
    data
  })
}

/**
 * 通过邮箱激活账号
 */
export function activeUserApi(data) {
  return request({
    url: api.activeUser,
    method: 'post',
    data
  })
}

/**
 * 通过邮箱激活账号页面设置密码
 */
export function setPasswordApi(data) {
  return request({
    url: api.setPassword,
    method: 'post',
    headers: headers2,
    data
  })
}

/**
 * 获取我的账号基本信息
 */
export function profileApi(params) {
  return request({
    url: api.profile,
    method: 'get',
    headers,
    params
  })
}

/**
 * 自动生成用户名
 */
export function genUsernameApi() {
  return request({
    url: api.genUsername,
    method: 'get'
  })
}

/**
 * 提交保存用户名
 */
export function saveProfileApi(data) {
  return request({
    url: api.saveProfile,
    method: 'post',
    data
  })
}

export function setUserProperties(params) {
  return request({
    url: api.setUserProperties,
    method: 'get',
    params
  })
}

// 绑定手机或邮箱
export function bindTelOrMailApi(data) {
  return request({
    url: api.bindTelOrMail,
    method: 'post',
    headers,
    data
  })
}

// 更换手机或邮箱
export function modifyTelOrMailApi(data) {
  return request({
    url: api.modifyTelOrMail,
    method: 'post',
    headers,
    data
  })
}

// 更换手机或邮箱
export function autoApi(data, head) {
  return request({
    url: api.drainageLogin,
    method: 'post',
    headers: Object.assign(headers, head),
    data
  })
}

export function getTicketInfo(params) {
  return request({
    url: api.getTicketInfo,
    method: 'get',
    params
  })
}

export function qrcodeConfig(params) {
  return request({
    url: api.qrcodeConfig,
    method: 'get',
    params
  })
}

/**
 * 登录页微信二维码生成
 */
export function thirdPartyQrcode(data) {
  return request({
    url: api.thirdPartyQrcode,
    method: 'post',
    data
  })
}

export function loginThirdParty(data, headers3) {
  data = Object.assign({}, loginConfig, data)
  const agree = store.getters.cookie_agree.agree
  const termTypes = data.termTypes
  if (agree && Array.isArray(termTypes)) {
    data.termTypes = [...termTypes, 1]
  }
  return request({
    url: api.loginThirdParty,
    method: 'post',
    headers: Object.assign({}, headers3, { useCaptcha: 1 }),
    data
  })
}

/**
 * 获取目标国家的语言映射
 */
export function langMapping(data) {
  return request({
    url: api.langMapping,
    method: 'post',
    data
  })
}

/**
 * 登录页微信二维码生成
 */
export function wxQrcodeApi(params) {
  return request({
    url: api.wxQrcode,
    method: 'get',
    params
  })
}

/**
 * 循环获取登陆结果
 */
export function wxQrcodePollApi(params) {
  return request({
    url: api.wxQrcodepoll,
    method: 'get',
    params
  })
}

/**
 * 循环获取登陆结果
 */
export function checkLoginIdApi(headers) {
  return request({
    url: api.checkLoginId,
    method: 'get',
    headers
  })
}

/**
 * 微信登录开关
 */
// export function getWxScanPageLoadApi() {
//   return request({
//     url: api.getWxScanPageLoad,
//     method: 'get'
//   })
// }

export function setPushConfig(data) {
  return request({
    url: api.setPushConfig,
    method: 'post',
    data
  })
}

export function createPassword(data) {
  return request({
    url: api.createPassword,
    method: 'post',
    data
  })
}

export function isolateTwoFactorBind(data) {
  return request({
    url: api.isolateTwoFactorBind,
    method: 'post',
    data
  })
}
